export enum WssInvoiceEventTypes {
    PDF_CREATED = "pdf_created",
}

export interface WssInvoicePayload {
    event: WssInvoiceEventTypes;
    requestId: string;
    class: string;
    id: string;
    companyId: string;
}
